import {
  VIEW_RECEIPT_API_REQUEST,
  VIEW_RECEIPT_API_SUCCESS,
  VIEW_RECEIPT_API_ERROR,
} from '../../../constants/cartActionNames';

import { cartApi } from '../../../apis/cart';

function viewReceiptApiRequest() {
  return {
    type: VIEW_RECEIPT_API_REQUEST,
    payload: true,
  };
}

function viewReceiptApiSuccess(cart, params) {
  return {
    type: VIEW_RECEIPT_API_SUCCESS,
    payload: cart,
    params,
  };
}

function viewReceiptApiError(err) {
  return {
    type: VIEW_RECEIPT_API_ERROR,
    payload: err,
  };
}

export function viewReceiptAction(params) {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(viewReceiptApiRequest());
    return cartApi
      .viewReceipt(state, params)
      .then(data => {
        dispatch(viewReceiptApiSuccess(data, params));
        return data;
      })
      .catch(error => {
        dispatch(viewReceiptApiError(error));
        throw error;
      });
  };
}

export default { viewReceiptAction };
